import { Pipe, PipeTransform } from '@angular/core';
import { BackendEntryType } from '../../../../data/src/lib/entities/treasury.model';

/**
 * Translation keys (not plain strings) so the operator-facing surfaces
 * follow the active locale. Consumers chain with the `translate` pipe:
 *
 *   {{ entry.EntryType | cashFlowEntryTypeLabel | translate }}
 */
const LABEL_KEYS: Record<BackendEntryType, string> = {
  [BackendEntryType.Sale]: 'TREASURY.CASH.TURN.TIMELINE_FILTER_ENTRY_TYPE_ENTRY',
  [BackendEntryType.Expense]: 'TREASURY.CASH.TURN.TIMELINE_FILTER_ENTRY_TYPE_EXIT',
  [BackendEntryType.Supply]: 'TREASURY.CASH.TURNS.CHARTS.TYPE_SUPPLY',
  [BackendEntryType.Withdrawal]: 'TREASURY.CASH.TURNS.CHARTS.TYPE_WITHDRAWAL',
  [BackendEntryType.Transfer]: 'TREASURY.CASH.TURN.TIMELINE_FILTER_ENTRY_TYPE_TRANSFER',
  [BackendEntryType.Adjustment]: 'TREASURY.CASH.TURN.TIMELINE_FILTER_ENTRY_TYPE_ADJUSTMENT',
};

@Pipe({ name: 'cashFlowEntryTypeLabel', standalone: true, pure: true })
export class CashFlowEntryTypeLabelPipe implements PipeTransform {
  transform(value: BackendEntryType): string {
    return LABEL_KEYS[value] ?? '';
  }
}
